import { render, staticRenderFns } from "./order_form.vue?vue&type=template&id=55d12e68&scoped=true"
import script from "./order_form.vue?vue&type=script&lang=js"
export * from "./order_form.vue?vue&type=script&lang=js"
import style0 from "./order_form.vue?vue&type=style&index=0&id=55d12e68&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d12e68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d12e68')) {
      api.createRecord('55d12e68', component.options)
    } else {
      api.reload('55d12e68', component.options)
    }
    module.hot.accept("./order_form.vue?vue&type=template&id=55d12e68&scoped=true", function () {
      api.rerender('55d12e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/transit_dealer_management/transit_distributor/form/order_form.vue"
export default component.exports